<template>
  <div class="wrapper">
    <div id="slideCaptcha"></div>
  </div>
</template>
<script>
export default {
  name: 'SlideCaptcha',
  data() {
    return {
      appkey: 'FFFF0N00000000009186',
      scene: 'nc_message',
      nc: null
    }
  },
  methods: {
    init() {
      const that = this
      // eslint-disable-next-line
      AWSC.use("nc", function (state, module) {
        that.nc = module.init({
          appkey: that.appkey,
          scene: that.scene,
          renderTo: "#slideCaptcha",
          success: function (data) {
            that.$emit('slideVerify', data)
          },
          fail: function (failCode) {
            window.console && console.log("失败",failCode)
          },
          error: function (errorCode) {
            window.console && console.log("异常",errorCode)
          }
        });
      })
    },
    reloadSlideCap() {
      this.nc.reset()
    }
  },
  mounted() {
    this.init()
  }
};
</script>
<style lang="scss">
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
